(function () {
  'use strict';

  function normalize(str) {
    return String(str || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function initBlog(root) {
    if (!root || root.dataset.nbReady === '1') return;
    root.dataset.nbReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-nb-card]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-nb-filter]'));
    var search = root.querySelector('[data-nb-search]');
    var empty = root.querySelector('[data-nb-empty]');
    var activeCategory = 'all';
    var query = '';

    function matchCard(card) {
      var cats = normalize(card.dataset.nbCategories || '');
      var hay = normalize(card.dataset.nbSearch || '');
      var catOk = activeCategory === 'all' || cats.split('|').indexOf(activeCategory) !== -1;
      var qOk = !query || hay.indexOf(query) !== -1;
      return catOk && qOk;
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var show = matchCard(card);
        card.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeCategory = normalize(btn.dataset.nbFilter || 'all');
        filters.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        apply();
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        query = normalize(search.value).trim();
        apply();
      });
    }

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-nb-blog]').forEach(initBlog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
